import React, { useEffect, useState } from "react";
// import Lottie from "lottie-react";

const Lottie = dynamic(() => import("lottie-react"), {
  ssr: false
});
import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import dynamic from "next/dynamic";
interface LottieAnimationProps extends GeneralPropsType {
  src: string;
  loop?: boolean;
  autoplay?: boolean;
}
const LottieAnimation: React.FC<LottieAnimationProps> = ({
  src,
  loop = true,
  autoplay = true,
  className,
  ...rest
}) => {
  const [animationData, setAnimationData] = useState<object | null>(null);
  useEffect(() => {
    fetch(src).then(response => response.json()).then(data => setAnimationData(data));
  }, [src]);
  return <div className={clsx(styles.container, className)} data-sentry-component="LottieAnimation" data-sentry-source-file="index.tsx">
      {animationData && <Lottie {...rest} animationData={animationData} loop={loop} autoplay={autoplay} style={{
      width: "100%",
      height: "100%"
    }} />}
    </div>;
};
export default LottieAnimation;